var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "portlet light" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "portlet-body" },
      [
        _c("gerenciais-filtro", {
          attrs: { "color-selected": "blue", "color-deselected": "white" },
        }),
        _vm._v(" "),
        _c("wes-message", _vm._b({}, "wes-message", _vm.messagePanel, false)),
        _vm._v(" "),
        _vm.data && _vm.data.length > 0
          ? _c(
              "div",
              [
                _vm._v("\n            Mostrar:  \n            "),
                _vm._l(this.camposAgrupados, function (item) {
                  return _c(
                    "label",
                    { key: item.index, staticClass: "mt-checkbox" },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(item.caption + "     ") +
                          "\n                "
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: item.visible,
                            expression: "item.visible",
                          },
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(item.visible)
                            ? _vm._i(item.visible, null) > -1
                            : item.visible,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.checkClick(item)
                          },
                          change: function ($event) {
                            var $$a = item.visible,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(item, "visible", $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    item,
                                    "visible",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(item, "visible", $$c)
                            }
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("span"),
                    ]
                  )
                }),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { attrs: { id: "pivotgrid" } }),
        _vm._v(" "),
        _c("br"),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "portlet-title" }, [
      _c("div", { staticClass: "caption" }, [
        _c(
          "span",
          {
            staticClass: "caption-subject font-green-sharp bold uppercase",
            attrs: { id: "TituloBalanceteGerencial" },
          },
          [_vm._v("Gerenciais")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }